<template>
  <div class="guarantor-new">
    <div class="gua-form-step-container">
      <div class="form-scroller">
        <vue-scroll>
        <Form ref="newForm" label-position="left" :label-width="180">
          <div class="padding-top-20"></div>
          <Divider orientation="left">确认保函信息</Divider>

          <FormItem label="项目名称">
            <h3>{{data.project ? data.project.name : '-'}}</h3>
          </FormItem>
          <FormItem label="受益人">
            <h3>{{data.beneficiary || '-'}}</h3>
          </FormItem>
          <FormItem label="被保证人">
            <h3>{{data.guaranteed || '-'}}</h3>
          </FormItem>
          <FormItem label="担保种类">
            <h3>{{getVarietyName(data.variety)}}</h3>
          </FormItem>
          <FormItem label="担保金额">
            <h3>{{data.amount ? (data.amount / 100).toFixed(2) + ' 元' : '-'}}</h3>
          </FormItem>
          <FormItem label="担保方式">
            <h3>{{data.gMethod === 0 ? '独立保证' : '联合保证'}}</h3>
          </FormItem>
          <FormItem label="保函有效期">
            <h3>{{data.gStartDate ? (data.gStartDate + ' ~ ' + data.gEndDate) : '-'}}</h3>
          </FormItem>
          <FormItem label="担保费总额">
            <h3>{{data.fee ? (data.fee / 100).toFixed(2) + ' 元' : '-'}}</h3>
          </FormItem>

          <Alert type="warning" show-icon style="margin-top:20px">
            请确认以上信息无误，提交后将进入审核流程。
          </Alert>

          <div class="padding-top-20"></div>
        </Form>
        </vue-scroll>
      </div>

      <div class="bottom-buttons">
        <Row :gutter="16">
          <Col span="4"><Button type="primary" ghost size="large" style="display:inline" long @click="backward">上一步</Button></Col>
          <Col span="16"><Button type="primary" size="large" long @click="submit">提交保函</Button></Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'guarantor-new-puyang-step4',
  props: {
    data: Object,
    correctionMode: Boolean
  },
  data () {
    return {
      loading: false,
      guaTypes: [],
      correctionId: null
    }
  },
  mounted () {
    if (this.correctionMode) {
      this.getPendingCorrection()
    } else if (!this.data.cityId || !this.data.project) {
      this.$router.push({path: '/guarantees/new-puyang/step1'})
    }
    this.initGuaTypes()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    backward () {
      this.$emit('go-backward')
    },
    async getPendingCorrection () {
      try {
        let corrections = await this.$Api.Guarantee.getCorrections(this.data.orderNumber)
        if (corrections && corrections instanceof Array && corrections.length > 0) {
          // status=0 待整改, status=2 未通过 - 都继续提交整改
          let pendingCorrection = corrections.find(c => c.status === 0 || c.status === 2)
          if (pendingCorrection) {
            this.correctionId = pendingCorrection.tid
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    async initGuaTypes () {
      return new Promise((resolve, reject) => {
        this.$Api.Guarantee.getGuaranteeVarieties().then(res => {
          this.guaTypes = res
          resolve(res)
        }).catch(err => {
          this.$Message.error(err.message)
          reject(err)
        })
      })
    },
    getVarietyName (varietyId) {
      if (this.guaTypes.length && varietyId) {
        let v = this.guaTypes.find(o => o.id === varietyId)
        return v ? v.fullName : '-'
      }
      return '-'
    },
    async submit () {
      this.$Spin.show()
      // Build the complete guarantee model
      let guarantee = {
        cityId: this.data.cityId,
        industryId: this.data.industryId,
        project: this.data.project,
        owner: this.data.owner,
        contractor: this.data.contractor,
        beneficiary: this.data.beneficiary,
        beneficiaryBusinessLicense: this.data.beneficiaryBusinessLicense,
        beneficiaryAddress: this.data.beneficiaryAddress,
        guaranteed: this.data.guaranteed,
        guaranteedBusinessLicense: this.data.guaranteedBusinessLicense,
        guaranteedAddress: this.data.guaranteedAddress,
        variety: this.data.variety,
        amount: this.data.amount,
        fee: this.data.fee,
        amountCostRatio: this.data.amountCostRatio,
        counterRatio: this.data.counterRatio,
        counterCash: this.data.counterCash,
        counterMortgage: this.data.counterMortgage,
        counter3rdparty: this.data.counter3rdparty,
        counterOther: this.data.counterOther,
        gMethod: this.data.gMethod,
        gStartDate: this.data.gStartDate,
        gEndDate: this.data.gEndDate,
        gFeeRate: this.data.gFeeRate,
        opName: this.data.opName,
        opContactTel: this.data.opContactTel,
        prjId: this.data.prjId,
        ownerId: this.data.ownerId,
        contractorId: this.data.contractorId,
        contractOssKeys: this.data.contractOssKeys,
        attachments: this.data.attachments,
        jointGuarantors: this.data.jointGuarantors
      }
      guarantee.guarantorId = this.$store.getters.guarantorInfo.id
      console.log('Submitting guarantee:', guarantee)

      // Correction mode
      if (this.correctionMode && this.correctionId) {
        let correctRaw = JSON.stringify(guarantee)
        this.$Api.Guarantee.submitCorrection({
          correctionId: this.correctionId,
          correctRaw: correctRaw
        }).then(() => {
          this.$Spin.hide()
          this.$Message.success('整改提交成功!')
          this.$router.push('/guarantees/detail/' + this.data.orderNumber)
        }).catch(err => {
          this.$Spin.hide()
          this.$Notice.error({
            title: '提交失败!',
            desc: err.message
          })
        })
        return
      }

      this.$Api.Guarantee.addGuarantee(guarantee).then(() => {
        this.$Spin.hide()
        this.$Message.success('保函提交成功!')
        this.$router.push('/guarantees/list')
      }).catch(err => {
        this.$Spin.hide()
        this.$Message.error('提交失败!' + err.message)
      })
    }
  }
}
</script>

<style lang="less" scoped>
.guarantor-new {
  position: relative;
  height: 100%;
}
.gua-form-step-container {
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  align-items: stretch;
  .form-scroller {
    flex: 1;
    overflow: auto;
  }
  .bottom-buttons {
  }
}
</style>